import { sdk } from 'src/utilities/sdk';

export async function sendWelcomeEmailToDiners(
  corpId: string,
  dinerIds: string[]
): Promise<void> {
  await sdk.http.post(
    `/corps/${corpId}/diners/bulk_send_welcome_email`,
    dinerIds
  );
}
